import {
  AIA_RELOCATION_SURFACE_WIDTH,
  AIA_RELOCATION_WORKSPACE_INSET,
} from '@packages/systems/designer/assistant';
import {emotionStyled, Z_INDEXES} from '@packages/utilities/styled';

/**
 * A fixed-position docked chat `<aside>` — the positioning skeleton only. It
 * shares the tertiary backdrop the inset designer "card" floats on and carries
 * no panel-specific padding or selectors, so each dock composes it with its own
 * content (and inner spacing). Pair with `DockedWorkspaceFrame` for the rounded
 * card gutter. `topOffset` (e.g. below a full-width top bar) is applied by the
 * consumer via `style`.
 */
export const DockedSurface = emotionStyled('aside')(
  {
    backgroundColor: '$backgroundTertiary',
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    paddingTop: AIA_RELOCATION_WORKSPACE_INSET,
    paddingBottom: AIA_RELOCATION_WORKSPACE_INSET,
    position: 'fixed',
    top: 0,
    width: AIA_RELOCATION_SURFACE_WIDTH,
    zIndex: Z_INDEXES.zIndexRightSidebar,

    '& > *': {
      flex: '1 1 auto',
      minHeight: 0,
    },
  },
  {
    variants: {
      side: {
        left: {left: 0},
        right: {right: 0},
      },
    },
  }
);
